import { AbstractModel, JsonObject, JsonProperty, DateConverter } from 'projects/core/src/public-api';
import { DayCard } from './day-card';

@JsonObject('model.time_card.TimeCard')
export class Editions extends AbstractModel {

    @JsonProperty(Number, 'cardId')
    cardId?: number;

    @JsonProperty(DateConverter, 'changeDate')
    changeDate?: Date;

    @JsonProperty(Number, 'editorId')
    editorId?: number;

    @JsonProperty(String, 'title')
    title?: string;

}